import script from "./BomCartSuggestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./BomCartSuggestion.vue?vue&type=script&setup=true&lang=ts"

import "./BomCartSuggestion.vue?vue&type=style&index=0&id=eb6aaa3e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb6aaa3e"]])

export default __exports__